let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("cm3wZ")]).then(() => parcelRequire('4cxzb'));